import { Logo } from "@app/components/AdminNavbar/components/Logo";
import { Mail, Xmark } from "iconoir-react";
import { useTranslation } from "react-i18next";
import i18next from "../../../../i18n";

i18next.addResourceBundle("en", "Footer", {
    powered_by: "Powered by",
    about: `Ditto is the fast, trusted solution for managing CSR compliance. 
    Ditto helps you strengthen your CSR management system (policies, actions, reporting) and prepare for CSR labels and certifications so that you can win you stakeholders' trust. 
    Dozens of companies already use Ditto to build stakeholders’ trust and boost their brand while cutting costs, time and efforts.`,
    contact_us: "Contact us to learn more",
});
i18next.addResourceBundle("fr", "Footer", {
    powered_by: "Propulsé par",
    about: `Ditto est la solution rapide et fiable pour gérer la conformité RSE.
    Ditto vous aide à renforcer votre système de management RSE (politiques, actions, reporting) et à vous préparer aux labels et certifications RSE pour gagner la confiance de vos parties prenantes.
    Des dizaines d'entreprises utilisent déjà Ditto pour renforcer la confiance de leurs parties prenantes et booster leur marque tout en réduisant les coûts, le temps et les efforts.`,
    contact_us: "Contactez-nous pour en savoir plus",
});

const Footer = ({ logoSrc }: { logoSrc?: string }) => {
    const { t } = useTranslation("Footer");
    return (
        <div className=" w-full border-t border-tertiary">
            <div className="pt-[60px] pb-[120px] flex justify-center space-x-[40px] ">
                <div className="w-[300px]">
                    {logoSrc && (
                        <div className="flex space-w-4 items-center">
                            <img className="max-h-[32px]" src={logoSrc} />
                            <Xmark className="text-black" />
                        </div>
                    )}
                    <Logo className="h-3" />
                </div>
                <div className="space-y-5">
                    <div className=" text-lg font-regular max-w-[780px]">
                        {t("about")}
                    </div>
                    <div className="flex space-x-2">
                        <Mail className="w-5 h-5 text-green" />
                        <a
                            className="text-green"
                            href="mailto:contact@trustditto.com"
                        >
                            {t("contact_us")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
